/*
 * CMP-005 Icon button — Phase A1. Blocks activation of a loading (aria-disabled) icon button: loading keeps focus, so the
 * browser would still fire click on Enter/Space. Runs in the capture phase so it also covers hosts that only flip the
 * attribute at run time. No dependencies.
 */
(function () {
  if (typeof document === 'undefined' || window.ncIconButtonInitialized) return;
  window.ncIconButtonInitialized = true;
  document.addEventListener('click', function (event) {
    var el = event.target.closest && event.target.closest('.nc-icon-button[aria-disabled="true"]');
    if (!el) return;
    event.preventDefault();
    event.stopImmediatePropagation();
  }, true);
})();
